import { useInt } from 'hooks/useInt';

import { Flag } from 'ui/atoms/Flag/Flag';

import styles from './GovernmentRegistryMarquee.module.scss';

type Registry = {
  code: string;
  name: string;
};

const REGISTRIES: Registry[] = [
  { code: 'gb', name: 'Companies House' },
  { code: 'de', name: 'Handelsregister' },
  { code: 'fr', name: 'Registre National des Entreprises' },
  { code: 'nl', name: 'KVK Handelsregister' },
  { code: 'es', name: 'Registro Mercantil' },
  { code: 'it', name: 'Registro delle Imprese' },
  { code: 'se', name: 'Bolagsverket' },
  { code: 'pl', name: 'Krajowy Rejestr Sądowy' },
  { code: 'us', name: 'SEC EDGAR' },
  { code: 'ie', name: 'Companies Registration Office' },
  { code: 'lu', name: 'RCS Luxembourg' },
  { code: 'ch', name: 'Registre du commerce' },
  { code: 'at', name: 'Firmenbuch' },
  { code: 'cz', name: 'Obchodní rejstřík' },
  { code: 'dk', name: 'Erhvervsstyrelsen' },
  { code: 'no', name: 'Brønnøysundregistrene' },
  { code: 'fi', name: 'Patentti- ja rekisterihallitus' },
  { code: 'sg', name: 'ACRA' },
  { code: 'au', name: 'ASIC' },
  { code: 'in', name: 'Ministry of Corporate Affairs' },
  { code: 'jp', name: 'National Tax Agency' },
  { code: 'br', name: 'Receita Federal' },
  { code: 'za', name: 'CIPC' },
  { code: 'mx', name: 'Registro Público de Comercio' },
  { code: 'ca', name: 'Corporations Canada' },
];

const TRACK = [...REGISTRIES, ...REGISTRIES];

export const GovernmentRegistryMarquee = () => {
  const { t } = useInt();

  return (
    <div className={styles.root} role="region" aria-label="Government registries sourced directly">
      <span className={styles.label}>{t('Sourced directly from')}</span>
      <div className={styles.mask}>
        <div className={styles.track}>
          {TRACK.map((registry, i) => (
            <span className={styles.item} key={`${registry.code}-${i}`}>
              <Flag code={registry.code} className={styles.flag} rounded />
              <span className={styles.itemName}>{registry.name}</span>
              <span className={styles.itemCode}>{registry.code.toUpperCase()}</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
